import styled, { css } from 'styled-components'
import media from 'styled-media-query'

export const Wrapper = styled.div`
  width: calc(100% - 40px);
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 20px;

  .container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    max-width: 608px;
    height: 100vh;
    max-height: 608px;

    ${media.lessThan('medium')`
      max-height: 552px;
    `}
  }
`

export const Content = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 70%;

    > form {
      width: 100%;
    }

    .forget-password-link {
      display: flex;
      width: 100%;
      justify-content: end;
      text-align: end;
      font-size: ${theme.font.sizes.xxxsmall};
      color: ${theme.colors.white};
      text-decoration: underline;
      margin-right: 20px;
      margin-bottom: 14px;
      margin-top: 8px;
      transition: ${theme.transition.default};

      :hover {
        filter: brightness(0.85);
      }
    }

    .register-link {
      color: ${theme.colors.white};
      font-family: ${theme.font.montserrat};
      font-weight: ${theme.font.semiBold};
      font-size: ${theme.font.sizes.xxsmall};
      text-decoration: none;
      margin-top: 26px;
      text-align: center;
      transition: ${theme.transition.default};

      :hover {
        filter: brightness(0.85);
      }
    }

    ${media.lessThan('medium')`
      svg{
        width: 182px;
        height: 42px;
      }
    `}
  `}
`

export const Subtitle = styled.h2`
  ${({ theme }) => css`
    color: ${theme.colors.white};
    font-family: ${theme.font.comfortaa};
    font-weight: ${theme.font.normal};
    font-size: ${theme.font.sizes.xlarge};
    letter-spacing: 12px;
    margin-top: 12px;
    margin-bottom: 64px;

    ${media.lessThan('medium')`
      margin-bottom: 24px;
    `}
  `}
`
